<template>
  <div class="flex items-start">
    <div class="w-full">
      <UploadFile
        :size="'sm'"
        :class="isEditedClass(fileKey, template.additional_data['file.key'])"
        :label="'Файл'"
        :text="'Прикрепите файл'"
        :type="'file'"
        v-model="fileKey"
      />
    </div>
    <TemplateButtons
      :show-save-button="isReadyToSave"
      @save="handleClickOnSave"
      @delete="handleClickOnDelete"
    />
  </div>
</template>

<script>
import UploadFile from '../../../../components/UploadFile'
import TemplateButtons from './TemplateButtons'
import { isEditedClass } from '../../../../helpers/helpers'

export default {
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  components: {
    TemplateButtons,
    UploadFile
  },
  data () {
    return {
      fileKey: this.template.additional_data['file.key'],
      filePath: ''
    }
  },
  computed: {
    isReadyToSave () {
      return (
        this.fileKey !== '' &&
        this.fileKey !== this.template.additional_data['file.key']
      )
    }
  },
  methods: {
    isEditedClass,
    async handleClickOnSave () {
      const validate = await this.$validator.validateAll()
      if (validate) {
        this.$emit('save', {
          id: this.template.id,
          new: this.template.new || false,
          message_type: 'file',
          additional_data: {
            'file.key': this.fileKey
          }
        })
      }
    },
    async handleClickOnDelete () {
      this.$emit('delete', {
        id: this.template.id,
        new: this.template.new || false
      })
    }
  }
}
</script>
